import PropTypes from 'prop-types';
import React from 'react';
import FormikTextField from 'src/components/FormikTextField/FormikTextField';
import Label from 'shared/components/label';

const propTypes = {
  name: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const DetailField = ({name, emoji, index}) => (
  <Label testId="impact-factor-detail-field">
    {`${emoji} ${name}`}
    <FormikTextField
      name={`answers[${index}].content`}
      type="textarea"
      placeholder="Tell us more"
    />
  </Label>
);

DetailField.propTypes = propTypes;

export default DetailField;
